// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomInput_container___Q7zy"};